import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

export const fetchCompanies = createRoutine('manageCompany/fetchCompanies')
export const fetchCompaniesPromiseCreator = promisifyRoutine(fetchCompanies)

export const approveCompany = createRoutine('manageCompany/approveCompany')
export const approveCompanyPromiseCreator = promisifyRoutine(approveCompany)
